
document.addEventListener('DOMContentLoaded', async () => {
    const $anchors = document.querySelectorAll(".article__content a");

    $anchors.forEach(function ($anchor) {
        if ($anchor.innerText.trim() === $anchor.innerHTML.trim()) {
            const url = $anchor.getAttribute("href");

            fetch(url)
                .then(function (response) {
                    if(!response.ok) {
                        throw new Error("Network response was not ok");
                    }
                    return response.text();
                })
                .then(function (html) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, "text/html");

                    let content = "";

                    const ogImage = doc.querySelector('meta[property="og:image"]');
                    if (ogImage) {
                        const src = ogImage.getAttribute("content");
                        content += '<div class="image-area"><figure class="image-wrapper" style="--aspect-ratio: 1.0;"><img src="' + src + '" alt=""></figure></div>'
                    }

                    let texts = "";

                    const ogTitle = doc.querySelector('meta[property="og:title"]');
                    if(ogTitle) {
                        texts += '<strong>' + ogTitle.getAttribute("content") + '</strong>';
                    }

                    const ogDescription = doc.querySelector('meta[property="og:description"]');
                    if(ogDescription) {
                        let description = ogDescription.getAttribute("content");
                        if(description.length > 57) {
                            description = description.slice(0, 57) + '...';
                        }
                        texts += '<p>' + description + '</p>';
                    }

                    const ogPrice = doc.querySelector('meta[property="og:price:amount"]');
                    if(ogPrice) {
                        texts += '<span>' + ogPrice.getAttribute("content") + '</span>';
                    }

                    if(texts) {
                        content += '<div class="text-area">' + texts + '</div>';
                    }

                    if(content) {
                        $anchor.classList.add("cta-link");
                        $anchor.innerHTML = content;
                    }
                })
                .catch(function (e) {
                    console.error("ctaエラー", e);
                });
        }
    });
});